import request from '@/utils/request'

export function getSupplierDepartmentList() {
  return request({
    url: '/api/mdm-service/supplierDepartment/list',
    method: 'get'
  })
}

export function getSupplierDepartmentById(id) {
  return request({
    url: `/api/mdm-service/supplierDepartment/${id}`,
    method: 'get'
  })
}

export function createSupplierDepartment(data) {
  return request({
    url: '/api/mdm-service/supplierDepartment/add',
    method: 'post',
    data
  })
}

export function updateSupplierDepartment(data) {
  return request({
    url: '/api/mdm-service/supplierDepartment/update',
    method: 'put',
    data
  })
}

export function deleteSupplierDepartment(id) {
  return request({
    url: `/api/mdm-service/supplierDepartment/delete/${id}`,
    method: 'post'
  })
}
